import { createTheme } from "@mui/material/styles";

export const muiTheme = createTheme({
  components: {
    MuiPickersOutlinedInput: {
      styleOverrides: {
        root: {
          "&:hover .MuiPickersOutlinedInput-notchedOutline": {
            borderColor: "#b3b3b3",
          },
          "&.Mui-focused:not(.Mui-error) .MuiPickersOutlinedInput-notchedOutline": {
            borderColor: "#2684ff",
          },
        },
      },
    },
  },
});
